export const isDeletedWhatsAppTemplate = (template) => (
  [template?.deletion_state, template?.provider_status, template?.catalog_status, template?.status]
    .some((value) => String(value || "").toLowerCase() === "deleted")
);

export const getWhatsAppTemplateSavedAt = (template) => {
  const currentVersion = (Array.isArray(template?.versions) ? template.versions : []).find((version) => (
    version.is_current === true
    || Number(version.template_version) === Number(template.current_version ?? template.active_version ?? template.template_version)
  ));
  const dates = currentVersion
    ? [currentVersion.created_at, template.updated_at, template.created_at, template.submitted_at]
    : Array.isArray(template?.versions)
      ? [template.updated_at, template.created_at, template.submitted_at]
      : [template?.created_at, template?.updated_at, template?.submitted_at];
  return dates.find((value) => value && !Number.isNaN(new Date(value).getTime())) || null;
};

export const uniqueWhatsAppTemplateMessages = (messages) => {
  const seen = new Set();
  return messages.map((message) => String(message || "").trim()).filter((message) => {
    const key = message.replace(/\s+/g, " ").replace(/[.!;]+$/, "").toLocaleLowerCase("pt-BR");
    if (!key || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

export const getWhatsAppTemplateBlockMessages = (template) => {
  const reasons = Array.isArray(template?.send_block_reasons) ? template.send_block_reasons : [];
  const codes = new Set(reasons.map((reason) => reason?.code));
  const redundantCodes = new Set();
  if (codes.has("content_changed")) redundantCodes.add("configuration_invalidated");
  if (codes.has("content_changed") || codes.has("configuration_invalidated")) {
    redundantCodes.add("configuration_not_ready");
    redundantCodes.add("configuration_required");
  }
  if (codes.has("configuration_required")) redundantCodes.add("configuration_not_ready");
  const currentVersion = (Array.isArray(template?.versions) ? template.versions : []).find((version) => version.is_current === true);
  const versionStatus = String(currentVersion?.provider_status || template?.provider_status || template?.status || "").toLowerCase();
  if (codes.has("version_not_approved") && ["draft", "submitting", "submitted", "rejected"].includes(versionStatus)) {
    redundantCodes.add("remote_not_approved");
  }
  const priority = [
    "remote_deleted", "remote_unavailable", "identity_missing", "remote_unsupported",
    "content_changed", "configuration_invalidated", "content_unverified",
    "remote_not_approved", "version_not_approved", "configuration_required", "configuration_not_ready",
  ];
  return uniqueWhatsAppTemplateMessages(reasons
    .filter((reason) => !redundantCodes.has(reason?.code))
    .map((reason, index) => ({ reason, index, priority: priority.includes(reason?.code) ? priority.indexOf(reason.code) : priority.length }))
    .sort((left, right) => left.priority - right.priority || left.index - right.index)
    .map(({ reason }) => typeof reason === "string" ? reason : reason?.message || String(reason?.code || "").replace(/_/g, " ")));
};
